import { GlobalState } from '../../reducers';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
const uploadSelector = (store: GlobalState) => store.apps.appManagement.upload;

export default {
  uploadSelector,
};
